'user client';

import React, { forwardRef, ComponentPropsWithRef } from 'react';

interface TextareaProps extends ComponentPropsWithRef<'textarea'> {
  children?: React.ReactNode;
}

/**
 * 共通テキストエリア
 */
const Textarea = forwardRef((props: TextareaProps, ref: React.ForwardedRef<HTMLTextAreaElement>) => {
  const { children, className, ...rest } = props;

  // デフォルトのCSSクラス
  const defaultClassName =
    'block p-2.5 text-base border border-gray-300 text-gray-900 bg-gray-50 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500';
  // デフォルトのCSSクラスとユーザーが指定したクラスをマージ
  const mergedClassName = `${defaultClassName} ${className || ''}`.trim();

  return (
    <div className="relative">
      <textarea ref={ref} className={`relative ${mergedClassName}`} {...rest} />
      <div className="absolute bottom-[8px] right-[8px]">{children}</div>
    </div>
  );
});

Textarea.displayName = 'Textarea';

export default Textarea;
